module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_7.12eb0f14.png";